import { ReactNode } from 'react';
import { Typography } from '../typography';
import { ClassName } from '../../../interfaces/classname';
import { Icon } from '../icon';
import Icons from '@/const/icons';

interface Props extends ClassName {
	children: ReactNode;
	imageSrc?: string;
	imageHeight?: string;
	classNameText?: string;
}

export const EmptyFiltersScreen: React.FC<Props> = ({
	className,
	children,
	imageSrc,
	imageHeight,
	classNameText,
}) => {
	return (
		<div className={`flex flex-col items-center justify-center ${className}`}>
			<Icon
				src={imageSrc || Icons.searchCaseEmptyState}
				className={imageHeight || '!h-[110px]'}
			/>
			<Typography
				type="regular-18"
				className={`text-center mt-4 ${classNameText}`}
			>
				{children}
			</Typography>
		</div>
	);
};
